import { CookieConsentPolicyRoute } from '@/App/AppRoutes/CookieConsentPolicyRoute';
import { HomeLayoutRoute } from '@/App/AppRoutes/HomeLayoutRoute';
import { PrivacyPolicyRoute } from '@/App/AppRoutes/PrivacyPolicyRoute';
import { ProtectedLayoutRoute } from '@/App/AppRoutes/ProtectedLayoutRoute';
import { TermsOfUseRoute } from '@/App/AppRoutes/TermsOfUseRoute';
import { AppRouteConfig } from '@/App/AppRoutes/types';

export const appRoutesConfig: AppRouteConfig[] = [
  HomeLayoutRoute,
  ProtectedLayoutRoute,
  CookieConsentPolicyRoute,
  TermsOfUseRoute,
  PrivacyPolicyRoute,
];
